import { config } from "@frameworks/web/config/domain";
class WebinarShareRepo {
    constructor(http) {
        this.http = http;
    }
    async shareWebinarByEmail(payload) {
        try {
            const shareEmail = await this.http.request({
                method: "PUT",
                url: config.adminuat + config.reportBase + "app-ewin/home/webinars/share",
                body: {
                    userId: "626705e9b9405c041d1899ca",
                    webinarId: payload.id,
                    emailList: payload.email,
                },
            });
            if (shareEmail) {
                return shareEmail.status;
            }
        }
        catch (e) {
            return false;
        }
    }
    async registrationWebinar(payload) {
        try {
            const registration = await this.http.request({
                method: "POST",
                url: "https://adminuat.edelweiss.in/dev/app-ewin/home/webinars/registration",
                body: {
                    type: "Guest",
                    name: payload.fName + ` ${payload.lName}`,
                    city: "Noida",
                    email: payload.email,
                    webinarId: payload.webinarId,
                },
            });
            if (registration) {
                return registration.status;
            }
        }
        catch (e) {
            return false;
        }
    }
}
export default WebinarShareRepo;
